





































import changeLogMixin from '@adobe/edex/frontend/views/course/settings/mixin';
import { checkObjectArrayDiff, getID } from '@adobe/edex/frontend/views/course/settings/constants';
import MemberSearch from '@adobe/edex/frontend/views/course/settings/course-settings-member-search.vue';
const getInitialState = initialCourse => ({
  staff: initialCourse.staff,
});

export default {
  mixins: [changeLogMixin],
  props: {
    initialCourse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return getInitialState(this.initialCourse);
  },
  components: {
    MemberSearch,
  },
  methods: {
    getAvatarStyle(avatarURL) {
      return {
        backgroundImage: `url(${avatarURL})`,
      };
    },
    redirectToMemberDetailPage(url) {
    window.location.href = `/community/member/${url}`;
    },
    onMemberChanged({ name, data }) {
      this[name] = data;
    },
    resetChanges() {
      Object.assign(this.$data, getInitialState(this.initialCourse));
    },
  },
  watch: {
     staff(current, previous) {
      if (previous !== current) {
        this.onChange({
          name: 'staff',
          data: current.map(getID),
          hasDiff: checkObjectArrayDiff(this.initialCourse.staff, current),
        });
      }
    },
  },
};
